import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import { SettlementPatchType, SettlementBulkType } from '@schemas'

/** 정산 (DISPATCH_PLAN §6). 백오피스 전용 — 스태프 토큰 */
export const getSettlementSummary = async ({
	query = { year: '' } as { year: string },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/settlement/summary',
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getSettlementRows = async ({
	query = { month: '', currency: '' } as { month: string; currency: string },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/settlement',
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateSettlement = async ({
	params = { orderId: '' },
	body = {} as SettlementPatchType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'put',
			uri: `/settlement/${encodeURIComponent(params.orderId)}`,
			body: body,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const bulkUpdateSettlement = async ({
	body = {} as SettlementBulkType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'put',
			uri: '/settlement/bulk',
			body: body,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const settlementApi = {
	getSettlementSummary,
	getSettlementRows,
	updateSettlement,
	bulkUpdateSettlement,
}

export default settlementApi
